import React, { Suspense, lazy } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

const Home = lazy(() => import("../pages/Home"));
const AddManageVideo = lazy(() => import("../pages/videos/AddManageVideo"));
const AddManageCourse = lazy(() => import("../pages/CreateCourse/AddManageCourse"));
const AddManageQuestionnaire = lazy(() => import("../pages/Questions/AddManageQuestionnaire"));
const AddManageResource = lazy(() => import("../pages/Resource/AddManageResource"));
const LoginHome = lazy(() => import("../pages/Home/LoginHome"));
const ForgotPage = lazy(() => import("../pages/ForgotPage"));
const AllCourses = lazy(() => import("../pages/Courses/AllCourses"));
const NotFound = lazy(() => import("../pages/NotFound"));
const ViewCourse = lazy(() => import("../pages/Courses/ViewCourse"));
const AssignCourse = lazy(() => import("../pages/Courses/AssignCourse"));
const Rti = lazy(() => import("../pages/Public/Rti"));
const WebsitePolicy = lazy(() => import("../pages/Public/WebsitePolicy"));
const PrivacyPolicy = lazy(() => import("../pages/Public/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../pages/Public/T&C"));
const CopyrightPolicy = lazy(() => import("../pages/Public/CopyrightPolicy"));
const ContactUs = lazy(() => import("../pages/Public/Contact"));
const WebInfoManager = lazy(() => import("../pages/Public/WebManger"));
const LoginPage = lazy(() => import("../pages/LoginPage"));
const AboutUs = lazy(() => import("../pages/Public/AboutUs"));
const Registeration = lazy(() => import("../pages/Registeration"));
const MyProfile = lazy(() => import("../pages/Profile/MyProfile"));
const AdminSettings = lazy(() => import("../pages/settings").then((module) => ({ default: module.AdminSettings })));
const AllReports = lazy(() => import("../pages/reports").then((module) => ({ default: module.AllReports })));
const CreatePlan = lazy(() => import("../pages/planing").then((module) => ({ default: module.CreatePlan })));
const ViewPlan = lazy(() => import("../pages/planing").then((module) => ({ default: module.ViewPlan })));
const AddManageTrainingEvent = lazy(() => import("../pages/TrainingEvents").then((module) => ({ default: module.AddManageTrainingEvent })));

function WithParams(Component) {
  return function WrappedComponent(props) {
    const params = useParams();
    return <Component {...props} {...params} />;
  };
}
const WithParamsComponent = WithParams(ViewCourse);

function RoutesComponent() {
  return (
    <Suspense fallback={<div className="text-center p-3">Loading...</div>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPage />} />
        <Route path="/register" element={<Registeration />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/rti" element={<Rti />} />
        <Route path="/websitepolicy" element={<WebsitePolicy />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/terms&conditions" element={<TermsAndConditions />} />
        <Route path="/copyrightpolicy" element={<CopyrightPolicy />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/wim" element={<WebInfoManager />} />
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <LoginHome />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <MyProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/createcourse"
          element={
            <PrivateRoute>
              <AddManageCourse />
            </PrivateRoute>
          }
        />
        <Route
          path="/addmanagevideo"
          element={
            <PrivateRoute>
              <AddManageVideo />
            </PrivateRoute>
          }
        />
        <Route
          path="/addmanagequestionnaire"
          element={
            <PrivateRoute>
              <AddManageQuestionnaire />
            </PrivateRoute>
          }
        />
        <Route
          path="/addmanageresource"
          element={
            <PrivateRoute>
              <AddManageResource />
            </PrivateRoute>
          }
        />
        <Route
          path="/allcourses"
          element={
            <PrivateRoute>
              <AllCourses />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewcourses/:courseId"
          element={
            <PrivateRoute>
              <WithParamsComponent />
            </PrivateRoute>
          }
        />
        <Route
          path="/assigncourse"
          element={
            <PrivateRoute>
              <AssignCourse />
            </PrivateRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <AllReports />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminsettings"
          element={
            <PrivateRoute>
              <AdminSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="/training-events"
          element={
            <PrivateRoute>
              <AddManageTrainingEvent />
            </PrivateRoute>
          }
        />
        <Route
          path="/createplan"
          element={
            <PrivateRoute>
              <CreatePlan />
            </PrivateRoute>
          }
        />
        <Route
          path="/viewplan"
          element={
            <PrivateRoute>
              <ViewPlan />
            </PrivateRoute>
          }
        />
        <Route
          path="/*"
          element={<NotFound />}
        />
      </Routes>
    </Suspense>
  );
}
export default RoutesComponent;
